import classnames from 'classnames';
import { useState, useEffect } from 'react';
import { createEditor, Descendant } from 'slate';
import { Editable, withReact, Slate, DefaultElement, RenderElementProps } from 'slate-react';

import boldIcon from 'src/assets/icons/bold.svg';
import italicIcon from 'src/assets/icons/italic.svg';
import underlinedIcon from 'src/assets/icons/underlined.svg';

import { CustomLeaf } from './CustomLeaf';
import styles from './RichTextEditor.module.scss';
import { Props } from './RichTextEditor.types';
import { RichTextEditorMarkButton } from './RichTextEditorMarkButton';
import { RichTextEditorToolbar } from './RichTextEditorToolbar';

const renderElement = (props: RenderElementProps) => {
  return <DefaultElement {...props} />;
};

const defaultValue = [
  {
    type: 'paragraph',
    children: [{ text: '' }],
  },
];

const RichTextEditor = (props: Props) => {
  const [editor] = useState(() => withReact(createEditor()));
  const { className, value = defaultValue, onChange, ...rest } = props;

  const [content, setContent] = useState(value);

  useEffect(() => {
    setContent(value);
  }, [value]);

  const handleChange = (newValue: Descendant[]) => {
    setContent(newValue);
    onChange?.(newValue);
  };

  return (
    <div className={classnames(styles.container, className)}>
      <Slate editor={editor} initialValue={content} onChange={handleChange}>
        <RichTextEditorToolbar className={styles.toolbar}>
          <RichTextEditorMarkButton format="bold" icon={boldIcon} />
          <RichTextEditorMarkButton format="italic" icon={italicIcon} />
          <RichTextEditorMarkButton format="underline" icon={underlinedIcon} />
        </RichTextEditorToolbar>
        <Editable
          className={styles.editor}
          renderElement={renderElement}
          renderLeaf={CustomLeaf}
          spellCheck
          autoFocus
          {...rest}
        />
      </Slate>
    </div>
  );
};

export default RichTextEditor;
